export default __webpack_public_path__ + "static/media/routerMan.bc28aace.png";